import { FolderOverviewState } from '../models'

export const folderOverviewInitialState: FolderOverviewState = {
  folder: null,
  retainedHoursStats: null,
  isLoading: false,
  trafficStatus: null,
}
